/**
 * AutomationRuleBuilder — the create/edit modal for a pipeline automation rule
 * (SE-5506). Render it with a `key` that changes per open (e.g. the edited rule
 * id or "new") so the form seeds fresh without a reset effect.
 * @module features/player-kanban/components/organisms/AutomationRuleBuilder
 */

export { default } from "./AutomationRuleBuilderContainer";
export type { AutomationRuleBuilderContainerProps } from "./AutomationRuleBuilderContainer";
